module.exports = __webpack_public_path__ + "img/icon-copy-purple.ce91f85d.svg";